import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { getDefaultProfile } from "../../../../../../store/profiles/profiles.selectors";
import { Desktop, TabletMobile } from "../../../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../../../hooks";

export const RoamingDevicesSubHeader = () => {
  const translate = useIntlTranslate();
  const defaultProfileId = useSelector((state) => getDefaultProfile(state).id);

  return (
    <Fragment>
      <FormattedMessage id={"roaming_devices_table_description"} />{" "}
      <Link
        to={`/settings/devices/${defaultProfileId}/roaming`}
        className={"link"}
        aria-label={translate("aria_click_here_to_install_sps_remote")}
      >
        <Desktop>
          <FormattedMessage id="click_here" />
        </Desktop>
        <TabletMobile>
          <FormattedMessage id="tap_here" />
        </TabletMobile>
      </Link>
    </Fragment>
  );
};
